import styled from "styled-components";

export const StyledMatchWrapper = styled.div`
  &.xss,
  &.xs,
  &.sm {
    .mls-c-match-list__match {
      &:hover:before {
        box-shadow: none;
        background: none;
      }
    }

    .mls-c-match-list__match-broadcaster {
      .mls-c-match-list__match-broadcasters {
        display: none;
      }
    }
  }

  &.md,
  &.lg,
  &.xl,
  &.xxl,
  &.xxxl {
    .mls-c-match-list-promo {
      width: 420px;

      .mls-c-match-promo {
        max-width: 420px;
      }
    }
  }
`;
